import ImportTaxModel from '@/api/setting/import-tax-model'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState
}

export const mutations = {
  ...baseMutations
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: { search: context.state.search }
      },
      attributes
    )

    return ImportTaxModel.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(...args) {
    return ImportTaxModel.store(args[1])
  },
  update(...args) {
    const { id, data } = args[1]
    return ImportTaxModel.update(id, data)
  }
}
